import { render, staticRenderFns } from "./messagetpl.vue?vue&type=template&id=1fe6d203"
import script from "./messagetpl.vue?vue&type=script&lang=js"
export * from "./messagetpl.vue?vue&type=script&lang=js"
import style0 from "./messagetpl.vue?vue&type=style&index=0&id=1fe6d203&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports